import script from "./InfoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoPage.vue?vue&type=script&setup=true&lang=js"

import "./InfoPage.vue?vue&type=style&index=0&id=68625a60&lang=css"

const __exports__ = script;

export default __exports__